module.exports = __webpack_public_path__ + "media/src/images/icon__magazinFalsch1-5299d055fb684263234c4a1f08118059.svg";